import { Box, Container, Stack, StackProps, styled } from '@mui/material';

import { UserRefresher } from '@/components/AppRouter/UserRefresher';

import { doNotForwardTheseProps } from '@/styles/utils';

export const LoaderContainer = styled(Box)(({ theme }) => ({
  minHeight: 406,

  [theme.breakpoints.up('lg')]: {
    minHeight: 352,
  },
}));

export const CardStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
  paddingBottom: theme.spacing(12),

  [theme.breakpoints.up('md')]: {
    alignItems: 'stretch',
    flex: 'unset',
    flexDirection: 'row',
    gap: theme.spacing(3),
    maxWidth: 1100,
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: `0 ${theme.spacing(1)}`,
    paddingBottom: theme.spacing(10),
    ':has(.MuiPaper-root:nth-of-type(4))': {
      justifyContent: 'center',
      alignItems: 'stretch',
    },
  },

  [theme.breakpoints.up('lg')]: {
    padding: 0,
  },
}));

export const ActionBar = styled(Box, {
  shouldForwardProp: doNotForwardTheseProps('isBackdropEnabled'),
})<{
  isBackdropEnabled?: boolean;
}>(({ theme, isBackdropEnabled }) => ({
  marginTop: theme.spacing(4),
  maxWidth: 360,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),

  [theme.breakpoints.down('lg')]: {
    background: isBackdropEnabled ? theme.palette.grey[100] : 'transparent',
    position: 'fixed',
    bottom: 0,
    zIndex: 1,
    padding: theme.spacing(2),
    justifyContent: 'center',
    alignItems: 'center',
  },

  [theme.breakpoints.up('md')]: {
    marginTop: theme.spacing(6),
  },

  [theme.breakpoints.up('lg')]: {
    position: 'static',
    marginTop: theme.spacing(6),
    maxWidth: 'unset',

    '.MuiButtonBase-root': {
      maxWidth: 360,
      margin: '0 auto',
    },
  },
}));

export const DrawerLogo = styled('img')(({ theme }) => ({
  display: 'block',
  width: 257,
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(2),
  [theme.breakpoints.down('lg')]: {
    marginTop: theme.spacing(4),
  },
}));

export const DrawerContainer = styled(Container)(({ theme }) => ({
  width: '100%',

  [theme.breakpoints.up('lg')]: {
    maxWidth: 400,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

export const AccountTypeTitle = styled((props: StackProps) => (
  <Stack gap={1} justifyContent="space-between" {...props} />
))(({ theme }) => ({
  marginLeft: theme.spacing(-2),
  marginRight: theme.spacing(-2),

  [theme.breakpoints.up('lg')]: {
    marginRight: 0,
  },
}));

export const DetailedPrice = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primaries[400],
  padding: `${theme.spacing(3)} ${theme.spacing(2)}`,
  borderTopLeftRadius: 16,
  borderBottomLeftRadius: 16,
  color: theme.palette.common.white,
  maxWidth: 180,

  '.MuiTypography-root': {
    color: theme.palette.common.white,
  },

  [theme.breakpoints.up('lg')]: {
    borderRadius: 16,
  },
}));

export const DetailsContent = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[800],
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(4),
  whiteSpace: 'pre-line',

  p: {
    margin: 0,
    marginBottom: theme.spacing(1.5),
  },

  ul: {
    marginTop: theme.spacing(1.5),
    marginBottom: theme.spacing(1.5),
    padding: 0,
    paddingLeft: theme.spacing(2.5),

    li: {
      listStyle: 'initial',
    },
  },
}));

export const StyledUserRefresher = styled(UserRefresher)(() => ({
  height: 'fit-content',
}));
